module.exports = __webpack_public_path__ + "img/drone-footer1.02d47871.jpg";